/* eslint-disable */
import { Node, Plugin, TextSelection } from 'tiptap';
import { replaceText } from 'tiptap-commands';
import { getMarkRange } from 'tiptap-utils';

export default class RouterLink extends Node {
  get name() {
    return 'file';
  }

  get schema() {
    return {
      attrs: {
        src: {
          default: null,
        },
        title: {
          default: null,
        },
        download: {
          default: null,
        },
      },
      group: 'inline',
      inline: true,
      atom: true,
      inclusive: false,
      toDOM: node => [
        'a',
        {
          href: node.attrs.src,
          download: node.attrs.download,
          onclick: "return false",
        },
        node.attrs.title,
      ],
      parseDOM: [
        {
          tag: 'a[href][download]',
          getAttrs: dom => {
            const src = dom.getAttribute('href');
            const title = dom.innerText;
            const download = dom.getAttribute('download');
            return { src, title, download };
          },
        },
      ],
    }
  }

  commands({ schema }) {
    return attrs => replaceText(null, schema.nodes[this.name], attrs)
  }

  get plugins() {
    return [
      new Plugin({
        props: {
          handleClick(view, pos) {
            const { schema, doc, tr } = view.state;
            const range = getMarkRange(doc.resolve(pos), schema.marks.link);

            if (!range) {
              return;
            }

            const $start = doc.resolve(range.from);
            const $end = doc.resolve(range.to);
            const transaction = tr.setSelection(new TextSelection($start, $end));

            view.dispatch(transaction);
          },
        },
      }),
    ];
  }
}



// WEBPACK FOOTER //
// ./src/others/file.js